import PropTypes from 'prop-types';
import React from 'react';
import { Tab, Tabs, Switch } from '@blueprintjs/core';
import { withTranslation } from 'react-i18next';
import { Tooltip2, Classes } from '@blueprintjs/popover2';

import Concordance from './Concordance';
//import { ThumbUpSharp } from '@material-ui/icons';


/* Unlike in stats, concordances are always presented by sub-corpus,
 * no `global` key which is a synthesis of all subcorpora.
*/
class Concordances extends React.PureComponent {

  state = {
    selectedTabId: (Object.keys(this.props.concordsByCorpus).length > 1)? "Global" : Object.keys(this.props.concordsByCorpus)[0],
    kwicClass:"flex",
    isOpenMetadata:false,
    isKwic: true,
  };

  handleTabChange = newTabId => this.setState({ selectedTabId: newTabId });
  
  handleClick = () => {
    this.setState({ isOpenMetadata: !this.state.isOpenMetadata });
    if (this.state.isOpenMetadata) {
      this.setState({kwicClass:"flex"});
    } else {
      this.setState({kwicClass:"flex-two-panels"});
    }
  };


  render() {
    const { concordsByCorpus, docMeta, lang, aligned_language, concordSpan, attr_val_doc, t, subCorpora } = this.props;
    const tabs = [];
    var alignedSents=false;

    // generate the global page, only when more than one page
    if (concordsByCorpus['_global_']) {
      const concord = <Concordance 
                          kwicClass={this.state.kwicClass}
                          isOpenMetadata={this.state.isOpenMetadata}
                          isKwic={this.state.isKwic}
                          concords={concordsByCorpus['_global_']} 
                          docMeta={docMeta} 
                          lang={lang} 
                          aligned_language={aligned_language}
                          concordSpan={concordSpan}
                          attr_val_doc={attr_val_doc}
                          collections={this.props.collections}
                          pasteQuery= {this.props.pasteQuery}
                          performSearch={this.props.performSearch}
                      />;
      const tab = <Tab key='Global' id='Global' title={t('global')} panel={concord} />;
      tabs.push(tab);
      //console.log('global');
    }

    // generate the indidual concordance pages
    const displayName=Object.keys(concordsByCorpus).length>16;
    for (var i=0;i<subCorpora.length;i++) {
      const subCorpus=subCorpora[i];
     
      if (concordsByCorpus[subCorpus]) {
        if (concordsByCorpus[subCorpus][0] && concordsByCorpus[subCorpus][0].alignedSent){
          alignedSents=true;
        }
        const title=(displayName) ? (" "+(i+1).toString()).slice(-2):subCorpus;
        const concord = <Concordance
                          name={subCorpus}
                          displayName={displayName}          
                          kwicClass={this.state.kwicClass}
                          isOpenMetadata={this.state.isOpenMetadata}
                          isKwic={this.state.isKwic}
                          concords={concordsByCorpus[subCorpus]} 
                          docMeta={docMeta} 
                          lang={lang} 
                          aligned_language={aligned_language}
                          concordSpan={concordSpan}
                          attr_val_doc={attr_val_doc}
                          collections={this.props.collections}
                          pasteQuery= {this.props.pasteQuery}
                          performSearch={this.props.performSearch}
                          queryNumber={this.props.queryNumber}
                      />;
        const tab = <Tab key={subCorpus} id={subCorpus} title={title} panel={concord} >
                      {displayName && <Tooltip2 content={subCorpus} className={Classes.TOOLTIP2_INDICATOR} placement="bottom" >…</Tooltip2>}
                    </Tab>;
        tabs.push(tab);
      }
    }

    return (
      <>
        <Switch
        label={t('KWIC/Unfolded')}
        checked={this.state.isKwic}
        onChange={() => this.setState(prevState => ({ isKwic: !prevState.isKwic }))}
        inline='true'
        />
        <Switch
          label={t('ShowMetaData')}
          checked={this.state.isOpenMetadata}
          onChange={this.handleClick}
          inline='true'
        />
        {alignedSents && 
          <span style={{color:"green"}}>{t('clickOnUnfoldedButtonToSeeParallelCorpus')}
          </span>
        }
        <Tabs
          selectedTabId={this.state.selectedTabId}
          onChange={this.handleTabChange}
          // renderActiveTabPanelOnly
        >
          {tabs}
        </Tabs>
      </>
    );
  }
}

Concordances.propTypes = {
  // look at `Results.prepConcordData` for more details
  subCorpora:PropTypes.array,
  collections: PropTypes.object,
  concordsByCorpus: PropTypes.object,
  docMeta: PropTypes.object,
  lang: PropTypes.string,
  aligned_language: PropTypes.string,
  concordSpan: PropTypes.number,
  attr_val_doc: PropTypes.object,
  pasteQuery: PropTypes.func,
  performSearch:PropTypes.func,
  queryNumber:PropTypes.number,

};

export default withTranslation()(Concordances);